<docs>
# domain-select Component

```pug
domain-select(
    @change="domainChange",
    tip="该功能仅用于基础流量代码自动检查"
    extra="为网站$domain绑定推广平台账户"
)
```
</docs>

<style scoped>
@import '../css/base/variables.css';
.domain-select {
    position: relative;
    padding: 0 1.4em;
    width: 300px;
    -webkit-user-select: none;
    user-select: none;

    & > .current-domain {
        position: relative;
        padding-right: 20px;
        cursor: pointer;

        & > span {
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    & span:hover {
        color: #fff;
    }
    & i:hover {
        color: #999;
    }
}

.select-panel {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 999;
    min-width: 100%;
    max-height: 182px;
    overflow-x: hidden;
    overflow-y: auto;
    /*padding: 10px 0;*/
    padding: 0;
    background: #fff;
    color: var(--Bluegrey);
    text-align: left;
    line-height: 2;
    
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0px;
    -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
    background-clip: padding-box;

    & > div {
        min-width: 300px;
        /*max-width: 440px;*/
        max-width: 400px;
        padding: 0 10px;
        line-height: 35px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;
        border-bottom: 1px solid var(--Linegrey);
        font-size: 14px;
    }
    & > div:last-child {
        border: 0;
    }
    & > div:hover {
        background-color: var(--Backgrey);
    }
    & > div.current {
        background-color: var(--Backgrey);
        font-weight: bold;
        color: #333;
    }
}

.select-panel::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

.select-panel::-webkit-scrollbar-thumb {
    background: #ced3d9;
    border-radius: 10px;
    border-radius: 30px;
}

.select-panel::-webkit-scrollbar-track {
    background: #eaeced;
}
.caret {
    position: absolute;
    top: 0;
    right: -10px;
    width: 30px;
    height: 100%;
}
.caret:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    margin: -3px 0 0 -3px;
    border-top: 7px dashed;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;
}
</style>

<template lang="pug">
div.domain-select(:class="{active: isRouterReport}")
    .current-domain(v-if="domainList.length")
        span(@click.stop="goToOverview", :title="`${currDomain.domain} - ${currDomain.domainTitle}`", v-if="currDomain.domain")
            | 网站分析 {{currDomain.domain ? '-' : ''}} {{`${currDomain.domain} - ${currDomain.domainTitle}`}}
        i.caret(v-if="currDomain.domain", @click.stop="visible = !visible", title="展开站点列表")
    .select-panel(v-show="visible", v-if="domainList.length && currDomain.domain", ref="panel", @mousewheel="onScroll($event)")
        div(
            v-for="item in domainList",
            @click.stop="selectDomain(item)",
            :class="{current: item.domain === currDomain.domain}"
        ) {{`${item.domain} - ${item.domainTitle}`}}
</template>

<script>
    import Cookie from 'js-cookie';
    /**
     * 选取 Object[] 中符合条件的第一个元素
     * 如果没有符合条件的  则默认返回第一个元素
     */
    const getMatchOrFirst = (list = [], key, val) => {
        let match = list.getParticularObjectInArray(key, val);
        return match || list[0];
    };

    export default {
        data() {
            return {
                visible: false,
                isRouterReport: false,
                panelHeight: 0
            };
        },
        computed: {
            domainList() {
                return this.$store.state.domainList || [];
            },
            currDomain() {
                 return this.$store.state.currentDomain || {};
            }
        },

        watch: {
            $route() {
                this.judgeActive();
            }
        },

        methods: {
            commitDomain(domain) {
                this.$store.commit('SET_DOMAINID', { domainId: domain.id });
                this.$store.commit('SET_CURRENT_DOMAIN', { domain });
                Cookie.set('_curdomainid', domain.id, {
                  path: '/'
                });
            },

            selectDomain(domain) {
                this.commitDomain(domain);
                this.hidePane();

                // 如果不在网站分析模块 则直接跳走
                if (!this.isRouterReport) {
                    this.$router.push('/web/overview');
                }
            },

            hidePane() {
                this.visible = false;
            },

            judgeActive() {
                this.isRouterReport = /^\/web\//.test(this.$router.currentRoute.path);
            },

            goToOverview() {
                this.visible = false;
                this.isRouterReport || this.$router.push('/web/overview');
            },

            onScroll(e) {
                let elem = this.$refs.panel;
                let scrollTop = elem.scrollTop;
                let dir = e.deltaY ? (e.deltaY < 0 ? 'up' : 'down') : void 0;

                if (dir === 'up' && scrollTop <= 0) {
                    return e.preventDefault();
                }

                if (dir === 'down' && (this.panelHeight + scrollTop) === elem.scrollHeight) {
                    return e.preventDefault();
                }
            }
        },
        
        created() {
            this.judgeActive();
        },

        mounted() {
            if (!this.$refs.panel) return;
            this.panelHeight = this.$refs.panel.offsetHeight;
            document.addEventListener('click', this.hidePane, false);
        },
        destroyed() {
            document.removeEventListener('click', this.hidePane);
        }
    }
</script>



// WEBPACK FOOTER //
// domain-select.vue?1cb9d960